var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "flex" }, [
          _c(
            "div",
            [
              _c("date-picker", {
                attrs: {
                  type: "month",
                  placeholder: "Выберите месяц",
                  clearable: false,
                },
                on: { change: _vm.getSalaryCalculation },
                model: {
                  value: _vm.selectedMonth,
                  callback: function ($$v) {
                    _vm.selectedMonth = $$v
                  },
                  expression: "selectedMonth",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.showAll,
                      expression: "showAll",
                    },
                  ],
                  attrs: { type: "checkbox", id: "ch_1" },
                  domProps: {
                    checked: Array.isArray(_vm.showAll)
                      ? _vm._i(_vm.showAll, null) > -1
                      : _vm.showAll,
                  },
                  on: {
                    change: [
                      function ($event) {
                        var $$a = _vm.showAll,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.showAll = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.showAll = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.showAll = $$c
                        }
                      },
                      _vm.updateVisibility,
                    ],
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "pl-2 pointer", attrs: { for: "ch_1" } },
                  [_vm._v("Показать выплаты")]
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.showSalaryProspects && !_vm.salaryProspects
            ? _c(
                "div",
                { staticClass: "ml-2" },
                [
                  _c("LoadingButton", {
                    attrs: {
                      title: "Просчитать прогноз",
                      className: "btn btn-outline-success btn-xs",
                      onClick: () => _vm.loadProspects(),
                      loading: _vm.prospectsLoading,
                      color: _vm.$constants.SUCCESS_COLOR,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.loading
          ? _c(
              "div",
              [
                _c("pulse-loader", {
                  staticClass: "text-center",
                  attrs: { loading: true, color: _vm.$constants.LOADING_COLOR },
                }),
              ],
              1
            )
          : _c("div", [
              _c("div", [
                _c(
                  "table",
                  {
                    staticClass:
                      "table table-sm table-hover table-striped salary_table mt-3",
                  },
                  [
                    _c("thead", [
                      _c("tr", [
                        _c("th"),
                        _vm._v(" "),
                        _c("th", [_vm._v("Сотрудник")]),
                        _vm._v(" "),
                        _vm.showSalaryProspects && _vm.salaryProspects
                          ? _c("th", [_vm._v("Прогноз")])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("th", [_vm._v("Сдельная зарплата")]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v("Общая сумма к выплате / Комментарий"),
                        ]),
                        _vm._v(" "),
                        _c("th"),
                        _vm._v(" "),
                        _c("th"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        !_vm.showAll
                          ? _vm._l(
                              _vm.usersAccountDetails,
                              function (user, index, i) {
                                return _vm.noVisible[user.id]
                                  ? _c(
                                      "tr",
                                      {
                                        key: user.id,
                                        class: {
                                          tr_green: _vm.notAllowToPay[user.id],
                                        },
                                      },
                                      [
                                        _c("td", [_vm._v(_vm._s(i + 1))]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(user.name) +
                                                " (" +
                                                _vm._s(user.id) +
                                                ")"
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            _vm._l(
                                              user.roles,
                                              function (role, i) {
                                                return _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge badge-info",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          role.name_title
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm.showSalaryProspects &&
                                        _vm.salaryProspects
                                          ? _c("td", [
                                              _vm.salaryProspects[user.id]
                                                ? _c("div", [
                                                    _c("p", [
                                                      _vm._v("заявки RUB: "),
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            Math.round(
                                                              _vm
                                                                .salaryProspects[
                                                                user.id
                                                              ].orders_sum
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _vm._v("заявки EUR: "),
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            Math.round(
                                                              _vm
                                                                .salaryProspects[
                                                                user.id
                                                              ].orders_sum_eur
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _vm._v("процент EUR: "),
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            Math.round(
                                                              _vm
                                                                .salaryProspects[
                                                                user.id
                                                              ].calculated_rate
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _vm._v("просчет: "),
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            Math.round(
                                                              _vm
                                                                .salaryProspects[
                                                                user.id
                                                              ].prospect_eur
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]),
                                                  ])
                                                : _vm._e(),
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.salaryPayments[user.id]
                                          ? [
                                              _c(
                                                "td",
                                                { attrs: { colspan: "1" } },
                                                [
                                                  _c("p", [
                                                    _vm._v("Заявки: "),
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.salaryPayments[
                                                            user.id
                                                          ].data.orders_sum.toLocaleString(
                                                            "ru-RU"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("p", [
                                                    _vm._v("EUR: "),
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.salaryPayments[
                                                            user.id
                                                          ].data.orders_sum_eur.toLocaleString(
                                                            "ru-RU"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("p", [
                                                    _vm._v("RATE: "),
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.salaryPayments[
                                                            user.id
                                                          ].data.rate
                                                        )
                                                      ),
                                                    ]),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("p", [
                                                    _vm._v("ЗП: "),
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.salaryPayments[
                                                            user.id
                                                          ].data.base_salary.toLocaleString(
                                                            "ru-RU"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                [
                                                  _c("div", [
                                                    _c("p", [
                                                      _vm._v("Выплата: "),
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.salaryPayments[
                                                              user.id
                                                            ].pay_date
                                                          )
                                                        ),
                                                      ]),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _vm._v(
                                                        "Период: " +
                                                          _vm._s(
                                                            _vm.moment(
                                                              _vm
                                                                .salaryPayments[
                                                                user.id
                                                              ].range_date_from
                                                            )
                                                          ) +
                                                          " -\n                        " +
                                                          _vm._s(
                                                            _vm.moment(
                                                              _vm
                                                                .salaryPayments[
                                                                user.id
                                                              ].range_date_to
                                                            )
                                                          )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$AllCurrencies[
                                                            _vm.salaryPayments[
                                                              user.id
                                                            ].currency_id
                                                          ].currency
                                                        ) +
                                                          ":\n                        "
                                                      ),
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.salaryPayments[
                                                              user.id
                                                            ].sum.toLocaleString(
                                                              "ru-RU"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.salaryPayments[
                                                            user.id
                                                          ].comment
                                                        )
                                                      ),
                                                    ]),
                                                  ]),
                                                  _vm._v(" "),
                                                  _vm.extraSalaryPayments[
                                                    user.id
                                                  ]
                                                    ? _vm._l(
                                                        _vm.extraSalaryPayments[
                                                          user.id
                                                        ],
                                                        function (bonus) {
                                                          return _c("p", [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  _vm.types[
                                                                    bonus
                                                                      .type_id
                                                                  ]
                                                                ) +
                                                                ": " +
                                                                _vm._s(
                                                                  _vm
                                                                    .$AllCurrencies[
                                                                    bonus
                                                                      .currency_id
                                                                  ].currency
                                                                ) +
                                                                "\n                        "
                                                            ),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  bonus.sum.toLocaleString(
                                                                    "ru-RU"
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                            _vm._v(
                                                              " (" +
                                                                _vm._s(
                                                                  bonus.comment
                                                                ) +
                                                                ")\n                        "
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-muted",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.printDate(
                                                                      bonus.created_at
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ])
                                                        }
                                                      )
                                                    : _vm._e(),
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      (_vm.$AllDivisions[
                                                        _vm.salaryData[user.id]
                                                          .salary_data
                                                          .division_id
                                                      ] &&
                                                        _vm.$AllDivisions[
                                                          _vm.salaryData[
                                                            user.id
                                                          ].salary_data
                                                            .division_id
                                                        ].user.short_name) ||
                                                        "Администрация"
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]),
                                            ]
                                          : [
                                              false
                                                ? _c("td", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.salaryData[
                                                            user.id
                                                          ].salary_data
                                                            .base_salary
                                                        ) +
                                                        "\n                    " +
                                                        _vm._s(
                                                          (_vm.$AllCurrencies[
                                                            _vm.salaryData[
                                                              user.id
                                                            ].salary_data
                                                              .base_currency
                                                          ] &&
                                                            _vm.$AllCurrencies[
                                                              _vm.salaryData[
                                                                user.id
                                                              ].salary_data
                                                                .base_currency
                                                            ].currency) ||
                                                            "не найдена валюта " +
                                                              _vm.salaryData[
                                                                user.id
                                                              ].salary_data
                                                                .base_currency
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                [
                                                  _vm.salaryData[user.id]
                                                    .salary_data.rate
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "small_font",
                                                          },
                                                          [
                                                            _c("p", [
                                                              _vm._v(
                                                                "заявки RUB:\n                          " +
                                                                  _vm._s(
                                                                    (_vm
                                                                      .ordersData[
                                                                      user.id
                                                                    ] &&
                                                                      _vm.ordersData[
                                                                        user.id
                                                                      ].orders_sum.toLocaleString(
                                                                        "ru-RU"
                                                                      )) ||
                                                                      0
                                                                  )
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("p", [
                                                              _vm._v(
                                                                "EUR: " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .ordersData[
                                                                      user.id
                                                                    ] &&
                                                                      _vm.ordersData[
                                                                        user.id
                                                                      ].orders_sum_eur.toLocaleString(
                                                                        "ru-RU"
                                                                      )
                                                                  )
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("p", [
                                                              _vm._v(
                                                                "RATE: " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .salaryData[
                                                                      user.id
                                                                    ]
                                                                      .salary_data
                                                                      .rate
                                                                  )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.ordersData[user.id]
                                                          ? [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "small_font",
                                                                },
                                                                [
                                                                  _c("p", [
                                                                    _vm._v(
                                                                      "CALCULATED RATE: " +
                                                                        _vm._s(
                                                                          _vm.ordersData[
                                                                            user
                                                                              .id
                                                                          ].calculated_rate.toLocaleString(
                                                                            "ru-RU"
                                                                          )
                                                                        ) +
                                                                        "\n                            EUR"
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("p", [
                                                                _vm._v(
                                                                  "Rate %: " +
                                                                    _vm._s(
                                                                      !_vm
                                                                        .currencyRates[
                                                                        _vm
                                                                          .usersPayCurrency[
                                                                          user
                                                                            .id
                                                                        ]
                                                                      ]
                                                                        ? "no currency rate"
                                                                        : Math.round(
                                                                            _vm
                                                                              .ordersData[
                                                                              user
                                                                                .id
                                                                            ]
                                                                              .calculated_rate /
                                                                              _vm
                                                                                .currencyRates[
                                                                                _vm
                                                                                  .usersPayCurrency[
                                                                                  user
                                                                                    .id
                                                                                ]
                                                                              ]
                                                                                .rate
                                                                          ).toLocaleString(
                                                                            "ru-RU"
                                                                          )
                                                                    ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      !_vm
                                                                        .currencyRates[
                                                                        _vm
                                                                          .usersPayCurrency[
                                                                          user
                                                                            .id
                                                                        ]
                                                                      ]
                                                                        ? "no currency rate"
                                                                        : _vm
                                                                            .currencyRates[
                                                                            _vm
                                                                              .usersPayCurrency[
                                                                              user
                                                                                .id
                                                                            ]
                                                                          ]
                                                                            .currency
                                                                    )
                                                                ),
                                                              ]),
                                                            ]
                                                          : _vm._e(),
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "p",
                                                    [
                                                      _vm._v(
                                                        "Fix Salary: " +
                                                          _vm._s(
                                                            _vm.salaryData[
                                                              user.id
                                                            ].salary_data
                                                              .base_salary
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            (_vm.currencyRates[
                                                              _vm.salaryData[
                                                                user.id
                                                              ].salary_data
                                                                .base_currency
                                                            ] &&
                                                              _vm.currencyRates[
                                                                _vm.salaryData[
                                                                  user.id
                                                                ].salary_data
                                                                  .base_currency
                                                              ].currency) ||
                                                              "не найден курс " +
                                                                _vm.salaryData[
                                                                  user.id
                                                                ].salary_data
                                                                  .base_currency
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                      _vm.salaryData[user.id]
                                                        .salary_data
                                                        .base_currency !==
                                                      _vm.usersPayCurrency[
                                                        user.id
                                                      ]
                                                        ? [
                                                            _vm._v(
                                                              "\n                        (" +
                                                                _vm._s(
                                                                  !_vm
                                                                    .currencyRates[
                                                                    _vm
                                                                      .usersPayCurrency[
                                                                      user.id
                                                                    ]
                                                                  ]
                                                                    ? "no currency rate"
                                                                    : Math.round(
                                                                        (_vm
                                                                          .salaryData[
                                                                          user
                                                                            .id
                                                                        ]
                                                                          .salary_data
                                                                          .base_salary *
                                                                          _vm
                                                                            .currencyRates[
                                                                            _vm
                                                                              .salaryData[
                                                                              user
                                                                                .id
                                                                            ]
                                                                              .salary_data
                                                                              .base_currency
                                                                          ]
                                                                            .rate) /
                                                                          _vm
                                                                            .currencyRates[
                                                                            _vm
                                                                              .usersPayCurrency[
                                                                              user
                                                                                .id
                                                                            ]
                                                                          ].rate
                                                                      )
                                                                ) +
                                                                "\n                        " +
                                                                _vm._s(
                                                                  !_vm
                                                                    .currencyRates[
                                                                    _vm
                                                                      .usersPayCurrency[
                                                                      user.id
                                                                    ]
                                                                  ]
                                                                    ? "no currency rate"
                                                                    : _vm
                                                                        .currencyRates[
                                                                        _vm
                                                                          .usersPayCurrency[
                                                                          user
                                                                            .id
                                                                        ]
                                                                      ].currency
                                                                ) +
                                                                ")\n                      "
                                                            ),
                                                          ]
                                                        : _vm._e(),
                                                    ],
                                                    2
                                                  ),
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "flex" },
                                                    [
                                                      !_vm.notAllowToPay[
                                                        user.id
                                                      ]
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group",
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .usersPayData[
                                                                        user.id
                                                                      ].sum,
                                                                    expression:
                                                                      "usersPayData[user.id].sum",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-control",
                                                                attrs: {
                                                                  type: "number",
                                                                  placeholder:
                                                                    "Сумма выплаты",
                                                                  "aria-describedby":
                                                                    "basic-addon2",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm
                                                                      .usersPayData[
                                                                      user.id
                                                                    ].sum,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      )
                                                                        return
                                                                      _vm.$set(
                                                                        _vm
                                                                          .usersPayData[
                                                                          user
                                                                            .id
                                                                        ],
                                                                        "sum",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "input-group-append",
                                                                },
                                                                [
                                                                  _c(
                                                                    "select",
                                                                    {
                                                                      directives:
                                                                        [
                                                                          {
                                                                            name: "model",
                                                                            rawName:
                                                                              "v-model",
                                                                            value:
                                                                              _vm
                                                                                .usersPayData[
                                                                                user
                                                                                  .id
                                                                              ]
                                                                                .currency,
                                                                            expression:
                                                                              "usersPayData[user.id].currency",
                                                                          },
                                                                        ],
                                                                      staticClass:
                                                                        "form-control",
                                                                      on: {
                                                                        change:
                                                                          [
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              var $$selectedVal =
                                                                                Array.prototype.filter
                                                                                  .call(
                                                                                    $event
                                                                                      .target
                                                                                      .options,
                                                                                    function (
                                                                                      o
                                                                                    ) {
                                                                                      return o.selected
                                                                                    }
                                                                                  )
                                                                                  .map(
                                                                                    function (
                                                                                      o
                                                                                    ) {
                                                                                      var val =
                                                                                        "_value" in
                                                                                        o
                                                                                          ? o._value
                                                                                          : o.value
                                                                                      return val
                                                                                    }
                                                                                  )
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .usersPayData[
                                                                                  user
                                                                                    .id
                                                                                ],
                                                                                "currency",
                                                                                $event
                                                                                  .target
                                                                                  .multiple
                                                                                  ? $$selectedVal
                                                                                  : $$selectedVal[0]
                                                                              )
                                                                            },
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.updateSum(
                                                                                user.id
                                                                              )
                                                                            },
                                                                          ],
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      _vm.allowedCurrencies,
                                                                      function (
                                                                        currency
                                                                      ) {
                                                                        return _c(
                                                                          "option",
                                                                          {
                                                                            key: currency.id,
                                                                            domProps:
                                                                              {
                                                                                value:
                                                                                  currency.id,
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                              " +
                                                                                _vm._s(
                                                                                  currency.currency
                                                                                ) +
                                                                                "\n                            "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.usersPayData[
                                                                user.id
                                                              ].comment,
                                                            expression:
                                                              "usersPayData[user.id].comment",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        attrs: { type: "text" },
                                                        domProps: {
                                                          value:
                                                            _vm.usersPayData[
                                                              user.id
                                                            ].comment,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              _vm.usersPayData[
                                                                user.id
                                                              ],
                                                              "comment",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.extraSalaryPayments[
                                                    user.id
                                                  ]
                                                    ? _vm._l(
                                                        _vm.extraSalaryPayments[
                                                          user.id
                                                        ],
                                                        function (bonus) {
                                                          return _c("p", [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  _vm.types[
                                                                    bonus
                                                                      .type_id
                                                                  ]
                                                                ) +
                                                                ": " +
                                                                _vm._s(
                                                                  _vm
                                                                    .$AllCurrencies[
                                                                    bonus
                                                                      .currency_id
                                                                  ].currency
                                                                ) +
                                                                "\n                        "
                                                            ),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  bonus.sum.toLocaleString(
                                                                    "ru-RU"
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                            _vm._v(
                                                              " (" +
                                                                _vm._s(
                                                                  bonus.comment
                                                                ) +
                                                                ")\n                        "
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-muted",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.printDate(
                                                                      bonus.created_at
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ])
                                                        }
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  !_vm.usersPayData[user.id]
                                                    .bonus
                                                    ? [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-outline-info btn-xs",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.addBonus(
                                                                  user.id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Еще выплата"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    : [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "flex",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group",
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .usersPayData[
                                                                          user
                                                                            .id
                                                                        ].bonus
                                                                          .sum,
                                                                      expression:
                                                                        "usersPayData[user.id].bonus.sum",
                                                                    },
                                                                  ],
                                                                  staticClass:
                                                                    "form-control",
                                                                  attrs: {
                                                                    type: "number",
                                                                    placeholder:
                                                                      "Комментарий",
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm
                                                                        .usersPayData[
                                                                        user.id
                                                                      ].bonus
                                                                        .sum,
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        )
                                                                          return
                                                                        _vm.$set(
                                                                          _vm
                                                                            .usersPayData[
                                                                            user
                                                                              .id
                                                                          ]
                                                                            .bonus,
                                                                          "sum",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "input-group-append",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "select",
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                _vm
                                                                                  .usersPayData[
                                                                                  user
                                                                                    .id
                                                                                ]
                                                                                  .bonus
                                                                                  .currency,
                                                                              expression:
                                                                                "usersPayData[user.id].bonus.currency",
                                                                            },
                                                                          ],
                                                                        staticClass:
                                                                          "form-control",
                                                                        on: {
                                                                          change:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              var $$selectedVal =
                                                                                Array.prototype.filter
                                                                                  .call(
                                                                                    $event
                                                                                      .target
                                                                                      .options,
                                                                                    function (
                                                                                      o
                                                                                    ) {
                                                                                      return o.selected
                                                                                    }
                                                                                  )
                                                                                  .map(
                                                                                    function (
                                                                                      o
                                                                                    ) {
                                                                                      var val =
                                                                                        "_value" in
                                                                                        o
                                                                                          ? o._value
                                                                                          : o.value
                                                                                      return val
                                                                                    }
                                                                                  )
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .usersPayData[
                                                                                  user
                                                                                    .id
                                                                                ]
                                                                                  .bonus,
                                                                                "currency",
                                                                                $event
                                                                                  .target
                                                                                  .multiple
                                                                                  ? $$selectedVal
                                                                                  : $$selectedVal[0]
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      _vm._l(
                                                                        _vm
                                                                          .usersPayData[
                                                                          user
                                                                            .id
                                                                        ].bonus
                                                                          .currencies,
                                                                        function (
                                                                          currency
                                                                        ) {
                                                                          return _c(
                                                                            "option",
                                                                            {
                                                                              key: currency,
                                                                              domProps:
                                                                                {
                                                                                  value:
                                                                                    currency,
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .$AllCurrencies[
                                                                                    currency
                                                                                  ]
                                                                                    .currency
                                                                                ) +
                                                                                  "\n                              "
                                                                              ),
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      0
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .usersPayData[
                                                                      user.id
                                                                    ].bonus
                                                                      .comment,
                                                                  expression:
                                                                    "usersPayData[user.id].bonus.comment",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              attrs: {
                                                                type: "text",
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .usersPayData[
                                                                    user.id
                                                                  ].bonus
                                                                    .comment,
                                                              },
                                                              on: {
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    )
                                                                      return
                                                                    _vm.$set(
                                                                      _vm
                                                                        .usersPayData[
                                                                        user.id
                                                                      ].bonus,
                                                                      "comment",
                                                                      $event
                                                                        .target
                                                                        .value
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ],
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                [
                                                  _c("p", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          (_vm.$AllDivisions[
                                                            _vm.salaryData[
                                                              user.id
                                                            ].salary_data
                                                              .division_id
                                                          ] &&
                                                            _vm.$AllDivisions[
                                                              _vm.salaryData[
                                                                user.id
                                                              ].salary_data
                                                                .division_id
                                                            ].user
                                                              .short_name) ||
                                                            "Администрация"
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("LoadingButton", {
                                                    attrs: {
                                                      title: "Выплатить",
                                                      className:
                                                        "btn btn-outline-success btn-xs",
                                                      onClick: () =>
                                                        _vm.makePayment(
                                                          user.id
                                                        ),
                                                      loading:
                                                        _vm.loadingBtns[
                                                          user.id
                                                        ],
                                                      color:
                                                        _vm.$constants
                                                          .SUCCESS_COLOR,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                        _vm._v(" "),
                                        _c("td", [
                                          !_vm.notAllowToPay[user.id]
                                            ? _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.selectedUsers[
                                                        user.id
                                                      ],
                                                    expression:
                                                      "selectedUsers[user.id]",
                                                  },
                                                ],
                                                attrs: { type: "checkbox" },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.selectedUsers[user.id]
                                                  )
                                                    ? _vm._i(
                                                        _vm.selectedUsers[
                                                          user.id
                                                        ],
                                                        null
                                                      ) > -1
                                                    : _vm.selectedUsers[
                                                        user.id
                                                      ],
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a =
                                                        _vm.selectedUsers[
                                                          user.id
                                                        ],
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          _vm.$set(
                                                            _vm.selectedUsers,
                                                            user.id,
                                                            $$a.concat([$$v])
                                                          )
                                                      } else {
                                                        $$i > -1 &&
                                                          _vm.$set(
                                                            _vm.selectedUsers,
                                                            user.id,
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              )
                                                          )
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        _vm.selectedUsers,
                                                        user.id,
                                                        $$c
                                                      )
                                                    }
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                        ]),
                                      ],
                                      2
                                    )
                                  : _vm._e()
                              }
                            )
                          : _vm._l(
                              _vm.salaryPayments,
                              function (payment, userId, i) {
                                return _c("tr", [
                                  _c("td", [_vm._v(_vm._s(i + 1))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(payment.user.name) +
                                          " (" +
                                          _vm._s(payment.user.id) +
                                          ")"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      _vm._l(
                                        payment.user.roles,
                                        function (role, i) {
                                          return _c(
                                            "span",
                                            { staticClass: "badge badge-info" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(role.name_title) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { attrs: { colspan: "1" } }, [
                                    _c("p", [
                                      _vm._v("Заявки: "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            payment.data.orders_sum.toLocaleString(
                                              "ru-RU"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v("EUR: "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            payment.data.orders_sum_eur.toLocaleString(
                                              "ru-RU"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v("RATE: "),
                                      _c("strong", [
                                        _vm._v(_vm._s(payment.data.rate)),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v("ЗП: "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            payment.data.base_salary.toLocaleString(
                                              "ru-RU"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _c("div", [
                                        _c("p", [
                                          _vm._v("Выплата: "),
                                          _c("strong", [
                                            _vm._v(_vm._s(payment.pay_date)),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "Период: " +
                                              _vm._s(
                                                _vm.moment(
                                                  payment.range_date_from
                                                )
                                              ) +
                                              " - " +
                                              _vm._s(
                                                _vm.moment(
                                                  payment.range_date_to
                                                )
                                              )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$AllCurrencies[
                                                payment.currency_id
                                              ].currency
                                            ) + ":\n                      "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                payment.sum.toLocaleString(
                                                  "ru-RU"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(_vm._s(payment.comment)),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _vm.extraSalaryPayments[userId]
                                        ? _vm._l(
                                            _vm.extraSalaryPayments[userId],
                                            function (bonus) {
                                              return _c("p", [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.types[bonus.type_id]
                                                    ) +
                                                    ": " +
                                                    _vm._s(
                                                      _vm.$AllCurrencies[
                                                        bonus.currency_id
                                                      ].currency
                                                    ) +
                                                    "\n                      "
                                                ),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      bonus.sum.toLocaleString(
                                                        "ru-RU"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " (" +
                                                    _vm._s(bonus.comment) +
                                                    ")\n                      "
                                                ),
                                                _c(
                                                  "span",
                                                  { staticClass: "text-muted" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.printDate(
                                                          bonus.created_at
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ])
                                            }
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          (_vm.$AllDivisions[
                                            payment.division_id
                                          ] &&
                                            _vm.$AllDivisions[
                                              payment.division_id
                                            ].user.short_name) ||
                                            "Администрация"
                                        ) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td"),
                                ])
                              }
                            ),
                      ],
                      2
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-right" },
                  [
                    _c("LoadingButton", {
                      attrs: {
                        title: "Выплатить выбранным сотрудникам",
                        className: "btn btn-outline-success btn-xs",
                        onClick: () => _vm.makePayment(),
                        loading: _vm.selectedLoading,
                        color: _vm.$constants.SUCCESS_COLOR,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Начисленные зарплаты")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }